import React, { useState, useEffect, useRef, useCallback } from 'react';
import { DTONOMY_SUPPORT_EMAIL } from '../../../helpers/constants'
import CollapsibleCard from '../common/CollapsibleCard'
import Form from 'react-bootstrap/Form';
import { getReportPhishingToEmail, setReportPhishingToEmail } from '../../../helpers/local_storage'


export default function ReportPhishingCard(props) {
    const [formState, setFormState] = useState({
        sendToEmail: "",
        reportNote: ""
    });

    useEffect(() => {
        // Set sendToEmail from localStorage value, if exists. 
        // Otherwise default to DTonomy support email
        setFormState((prevState) => ({
            ...prevState, // copy existing state properties
            sendToEmail: getReportPhishingToEmail() || DTONOMY_SUPPORT_EMAIL // set new value
        }));
    }, []);

    const handleChange = (event) => {
        const {name, value} = event.target;
        setFormState((prevState) => ({
            ...prevState, // copy existing state properties
            [name]: value // Set new target value
        }));
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        setReportPhishingToEmail(formState.sendToEmail);
        openReportPhishingForm();
    }

    const openReportPhishingForm = () => {
        const emails = formState.sendToEmail.split(",").map(item => item.trim());
        const subject = "Phish AIR suspected phishing email report";
        const userName = Office.context.mailbox.userProfile.displayName || Office.context.mailbox.userProfile.emailAddress;
        const htmlBody = (`
            <p>The attached email is being reported as suspicious by ${userName} via Phish AIR</p>
            <br>
            <p>Additional Note From Sender:</p>
            <br>
            ${formState.reportNote}
            `
        );

        Office.context.mailbox.displayNewMessageForm({
          toRecipients: emails,
          subject: subject,
          htmlBody: htmlBody,
          attachments :
                [
                    { 
                        type: "item", 
                        itemId : Office.context.mailbox.item.itemId, 
                        name: `${Office.context.mailbox.item.subject || subject}.eml` }
                ],
                options : { asyncContext: null },
                callback : function (asyncResult)
                {
                    if (asyncResult.status == "failed")
                    {
                        console.log("Action failed with error: " + asyncResult.error.message);
                    }
                }
        });
      }

    return (
        <CollapsibleCard header="Report Phishing" ctrlName="reportPhishing" isOpen={true}>
            <p className="card-text">
                Send suspicious email as an attachment to the specified email(s) below. <br/><b>Use comma separation for sending to multiple email addresses.</b>
            </p>
            <Form onSubmit={handleSubmit} autoComplete="off">
                <Form.Group controlId="sendToEmail">
                    <Form.Label srOnly>Send To Email:</Form.Label>
                    <Form.Control 
                        type="email" 
                        multiple="true"
                        name="sendToEmail"
                        placeholder="Enter Email"
                        value={formState.sendToEmail}
                        onChange={handleChange}/>
                </Form.Group>
                <Form.Group controlId="phishingReportNote" className="mt-2">
                    <Form.Label srOnly>Add Note (Optional): </Form.Label>
                    <Form.Control 
                        as="textarea" 
                        name="reportNote"
                        rows={3} 
                        placeholder="Add Note (Optional)" 
                        onChange={handleChange}
                    />
                </Form.Group>
                <div>
                    <input 
                        type="submit" 
                        value="Send Report" 
                        className="dt_link font-weight-bold" 
                    />
                </div>
            </Form>
        </CollapsibleCard>
    );
  }
  